import React, { FC, useMemo } from 'react';
import { transformNames } from '../../utils';
import { copyToClipboard } from 'components/ui/utils';
import { CopyIcon, Wrapper } from './transcript-summary.styled';
import { Header, IconWrapper, MessageText } from '../transcript-common';

interface Props {
  summary: string;
}

export const TranscriptSummary: FC<Props> = ({ summary }) => {
  const transformedSummary = useMemo(() => transformNames(summary), []);

  const copyInBuffer = (e: React.MouseEvent<HTMLImageElement>) => {
    e.stopPropagation();
    copyToClipboard(transformedSummary, false, {
      success: 'Скопировано в буфер обмена',
      error: 'Упс...Что-то пошло не так, повторите попытку',
    });
  };

  return (
    <Wrapper>
      <Header>
        Краткое содержание (нейросеть){' '}
        <IconWrapper>
          <CopyIcon onClick={(e) => copyInBuffer(e)} />
        </IconWrapper>
      </Header>
      <MessageText>{transformedSummary}</MessageText>
    </Wrapper>
  );
};
